import { Component, ViewChild } from '@angular/core';
import { CustomReportingService } from '@app/modules/reporting/services/custom-reporting.service';
import { CustomReportInformationForm, CustomReportFiltersForm } from '@app/modules/forms/reporting/components';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifyService } from '@app/services';
import { CustomReportQuery } from '@app/models/reporting/custom-report-query.model';
import { CustomReportFilter } from '@app/models/reporting/custom-report-filter.model';
import { TranslatableKey } from '@app/types/translatable.type';

const filterValuesToDelete = (
    initialList: CustomReportFilter[],
    selectedList: CustomReportFilter[]
): CustomReportFilter[] => {
    return initialList.filter((customReportFilter) => !selectedList.includes(customReportFilter));
};
@Component({
    selector: 'app-custom-report-store',
    templateUrl: './custom-report-store.template.html',
    styleUrls: ['./custom-report-store.style.scss'],
})
export class CustomReportStoreView {
    @ViewChild('reportInformationForm', { static: true }) reportInformationForm: CustomReportInformationForm;
    @ViewChild('filtersForm', { static: true }) filtersForm: CustomReportFiltersForm;
    isLoading = false;
    title: TranslatableKey = 'reporting.custom-reports.createACustomReport';
    customReportQuery: CustomReportQuery = new CustomReportQuery();
    initialCustomReportFilters: CustomReportFilter[];
    deletedCustomFilters: CustomReportFilter[];

    constructor(
        private customReportingService: CustomReportingService,
        private notify: NotifyService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        if (this.route.snapshot.data.models) {
            this.customReportQuery = this.route.snapshot.data.models.get('customReportQuery');
            this.title = 'reporting.custom-reports.editCustomReport';
            this.initialCustomReportFilters = this.customReportQuery.filters;
        }
    }

    onSave(): void {
        if (this.reportInformationForm.form.invalid || this.filtersForm.form.invalid) {
            return;
        }

        this.isLoading = true;

        this.setCustomReportColumnAttributes();

        this.customReportingService
            .saveCustomReport(this.customReportQuery)
            .then((customReportQuery: CustomReportQuery) => {
                this.saveCustomReportFilters();

                if (this.initialCustomReportFilters) {
                    this.deleteCustomReportFilters();
                }

                this.notify.success('reporting.custom-reports.customReportSaved');
                this.router.navigate(['/reporting', 'custom-reports', customReportQuery.id, 'report']);
            });
    }

    setCustomReportColumnAttributes(): void {
        this.customReportQuery.reportType = 'employee';
        this.customReportQuery.name = this.reportInformationForm.reportName;
        this.customReportQuery.columns = this.reportInformationForm.getSelectedColumns();
    }

    saveCustomReportFilters(): void {
        const selectedFilters = this.filtersForm.getSelectedFilters();

        selectedFilters.forEach((customReportFilter) => {
            if (customReportFilter.data.property) {
                this.customReportingService.saveCustomReportFilters(this.customReportQuery.id, customReportFilter.data);
            }
        });
    }

    deleteCustomReportFilters(): void {
        const selectedCustomFilters = this.filtersForm.getSelectedFilters().map((filter) => filter.data);
        const deletedFilters = filterValuesToDelete(this.initialCustomReportFilters, selectedCustomFilters);

        deletedFilters.forEach((customReportFilter) => {
            this.customReportingService.deleteCustomReportFilter(this.customReportQuery.id, customReportFilter);
        });
    }
}
